import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Offer, OfferCodeDisplayType, OfferCodeType, OfferLocationType } from 'src/models/Offer';
import { RetailerLinkType, RetailerWithLocations } from 'src/models/Retailer';
import { RetailerLocation } from 'src/models/RetailerLocation';
import { ApiService } from '../api.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Category } from 'src/models/Category';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import { VisibilityStatus } from 'src/models/VisibilityStatus';
import { LocalitiAuthService } from '../localiti-auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-retailer',
  templateUrl: './retailer.component.html',
  styleUrls: ['./retailer.component.scss']
})
export class RetailerComponent implements OnInit {
    private sub: any;
    retailer: RetailerWithLocations;
    offers: Offer[] = [];
    firstLoad = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];
   
    allCats : Category[] = [];
    filteredCats : Category[] = [];
    @ViewChild('catInput') catInput: ElementRef<HTMLInputElement>;
    private async getCats() : Promise<void> {
      if (!this.allCats || !this.allCats.length) {
        this.allCats = await this.api.getCategories();
        await this.updateCategories();
      }
    }
    constructor(private snackBar: MatSnackBar, private route: ActivatedRoute, private api: ApiService, private router : Router, private auth: LocalitiAuthService) {
    }

    private async updateCategories() : Promise<void> {      
      this.filteredCats = this.allCats.filter(x=> !this.retailer || !this.retailer.categoryIds || !this.retailer.categoryIds.includes(x.id));
      console.log("filtered is ", this.filteredCats);
    }

    async addCat(event: MatChipInputEvent): Promise<void> {
      // const value = (event.value || '').trim();
      // console.log("AddCat event has:");
      // console.log(event.value)
  

      // // if (value) {
      // //   this.retailer.categoryIds.push(value);
      // // }
      // await this.updateCategories();

    //  event.chipInput!.clear();

    }
  
    async addCatToRetailer(value: string): Promise<void> {
      
      console.log("AddCatToRetailer event has:");
      console.log(value)
  

      if (value) {
        this.retailer.categoryIds.push(value);
      }
      await this.updateCategories();

    //  event.chipInput!.clear();

    }

    async removeCat(cat) {
      console.log("removing cat")
      const index = this.retailer.categoryIds.findIndex(x=> x == cat);
      console.log("removing cat " + index);
      if (index >= 0) {
        this.retailer.categoryIds.splice(index, 1);
      }
      await this.updateCategories();
    }
  
    selectedCat(event: MatAutocompleteSelectedEvent): void {
      console.log("selected");
      this.catInput.nativeElement.blur();
      this.addCatToRetailer(event.option.value);
    }

    makeDisplayAddress(loc: RetailerLocation) : string {
      if (!loc) {
        return "";
      }

      let disp = "";
      if (loc.address1) {
        disp = disp + loc.address1;
      }
      if (loc.city) {
        if (disp) disp += " ";
        disp += loc.city;
      }
      if (loc.state) {
        if (loc.city) disp +=", ";
        else if (disp) disp += " ";
        disp += loc.state;
      }
      if (loc.postalCode) {
        if (disp) disp += " ";
        disp += loc.postalCode;
      }
      if (!disp) {
        disp = "(New Location)";
      }
      return disp;
    }
    ngOnInit() {
      this.sub = this.route.params.subscribe(params => {
        console.log("got params");
        
         this.loadLocation(params['retailerId']);
      });
    }

    getCat(value) {
      return this.allCats.find(x=> x.id == value);
    }
  isNew: boolean = false;
  private async loadLocation(retailerId: string) {
    this.isNew = false;
    this.largeImageType = null;
    this.largeImageBlob = null;
    const proms = [];
    let retailer;
    let offers;
    await this.getCats();
    if (retailerId === "new") {
      this.isNew = true;
      this.retailer = {
        id: null,
        name: "",
        description: "",
        webSiteUrl: null,
        smallImageUrl: null,
        largeImageUrl: null,
        links: [],
        locations: [],
        categoryIds: [],
        visibility: VisibilityStatus.Private
      };
      this.offers = [];
      await this.updateCategories();
    } else {
      proms.push(this.api.getRetailer(retailerId).then(async x=> {
        console.log("got retailer");
        if (!x.links) {
          x.links = [];
        }
        retailer = x;
        await this.updateCategories();
      }));
      proms.push(this.api.getOffersForRetailer(retailerId).then(x=> {
        console.log("got offers");
        offers = x;
      }));
      await Promise.all(proms);
      this.retailer = retailer;
      //const o = await this.api.getOffersForRetailer(retailerId);
      this.offers = offers;
      console.log("got offers for retailer: " + JSON.stringify(offers));
      setTimeout(() => { this.firstLoad = false;}, 1000);
    }
    
  }
  locationDeleted(loc) {
    console.log("delte loc: ");
    console.log(loc);
  }
  largeImagePickerConf = {
    borderRaduis: "5%",
    language: "en",
    width: "300px",
    height: "150px"
  };
  largeImageType: string = null;
  largeImageBlob: string = null;
  spinnerShown: boolean = false;
  onLargeImageChange(event: string) {  
    if (event == null) {
      this.largeImageType = null;
      this.largeImageBlob = null;
      return;
    }

    let idx = event.indexOf(";");
    let type : any = event.substr(0, idx);
    type = type.split("data:")[1];
    let data = event.split(";base64,")[1];
    this.largeImageType = type;
    this.largeImageBlob = data;
  }
  async delete() {
    if (confirm("Are you sure you want to delete this business, all of its locations and offers?  This cannot be undone!")) {
      try {
        this.spinnerShown = true;
        this.api.deleteRetailer(this.retailer.id);
        this.router.navigate(['retailers']);
      }
      finally {
        this.spinnerShown = false;
      }
    }
  }
  async save() {
    console.log("clicked!");
    let copy = JSON.parse(JSON.stringify(this.retailer));
    if (this.largeImageBlob && this.largeImageType) {
      copy.largeImageUrl_blob = this.largeImageBlob;
      copy.largeImageUrl_mime = this.largeImageType;
    }
    
    let res : RetailerWithLocations;
    if (this.isNew) {
      try {
        res = await this.api.createRetailer(copy);
        this.snackBar.open("Saved!", null, {duration: 1000, panelClass: ['snackbar-success']});
      } catch (e) {
        this.snackBar.open("There was a problem saving.", null, {duration: 5000, panelClass: ['snackbar-error']});
        console.error(e);
        return
      }
      
      this.loadLocation(res.id);
      this.router.navigate(["/retailers", res.id], {replaceUrl: true});
      return;
    } else {
      res = <RetailerWithLocations>(await this.api.patchRetailer(copy));
      const locs = this.retailer.locations;
      const proms = [];
      const updatedLocs: RetailerLocation[] = [];  
     

      for (let loc of locs) {
        if (!loc.id && !loc.isDeleted) {
          proms.push(this.api.createRetailerLocation(res.id, loc).then(x=> {
            if (x) {
              updatedLocs.push(x);
            }
          }));
        }
        else if (loc.hasChanges && !loc.isDeleted) {
          proms.push(this.api.patchRetailerLocation(res.id, loc).then(x=> {
            if (x) {
              updatedLocs.push(x);
            }
          }));
        } else if (loc.isDeleted) {
          proms.push(this.api.deleteRetailerLocation(res.id, loc));
        } else if (!loc.isDeleted) {
          updatedLocs.push(loc);
        }
      }
      try {
        await Promise.all(proms);
        this.snackBar.open("Saved!", null, {duration: 1000, panelClass: ['snackbar-success']});
      } catch (e) {
        console.error(e);
        this.snackBar.open("There was a problem saving.", null, {duration: 5000, panelClass: ['snackbar-error']});
      }
      res.locations = updatedLocs;
      await this.auth.forceReauth();
    }    
    
    this.retailer = res;
    this.largeImageType = null;
    this.largeImageBlob = null;
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  addLink() {
    if (!this.retailer.links) {
      this.retailer.links = [];
    }
    this.retailer.links.push({name:'', type: RetailerLinkType.Website, url:''});

  }

  removeLink(link) {
    let idx = this.retailer.links.indexOf(link);
    if (idx >= 0) {
      this.retailer.links.splice(idx, 1);
    }
  }
  async addLocation() {
    console.log("adding location");
    const newLoc : RetailerLocation = {
      id: null,
      address1: "",
      city: "",
      state:"",
      postalCode:"",
      geofenceRadiusKM: 1,
      visibility: VisibilityStatus.Private
    };
    this.retailer.locations.push(newLoc);
  }
}
  